import Footer from "../../footer"
import NavBar from "../../nav"

const RvsmOperations = () => {
  return <div className='rvsm-operations'>
    <NavBar />
    <div>
      <section className="clean-block pfa-content clearfix">
        <div className="divider sections">
          <h1>Reduced Vertical Separation Minimum (RVSM)</h1>
          <div className="headline-divider sections"></div>
          <h2>Domestic and International Operations</h2>
          <h3>Keeping up-to-date with the FAA.</h3>
        </div>
      </section>
      <section className="clean-block clearfix">
			<div className="container content-container about-container">	
				<div className="prose">RVSM Operations have changed with the advent of <span className="highlight">ADS-B per Part 91 Appendix G</span> as detailed in <span className="highlight">FAA guidance AC 91-85B</span>.</div>
				<div className="prose">For domestic operations, there is no need for issuance of a LOA or OpSpecs, however for operators application for authorization of RVSM is still required when:</div>
				<div className="container-fluid">					
					<div className="row">
						<div className="col-sm tiles">
							<div className="header">RVSM Airspace</div>
							<div className="content">The aircraft is operated in RVSM airspace where the FAA can not successfully monitor the aircraft's height-keeping performance.</div>
						</div>
						<div className="col-sm tiles">
							<div className="header">Foreign Airspace</div>
							<div className="content">The operator intends to conduct RVSM operations in foreign airspace where the State authority requires a specific RVSM operational authorization</div>
						</div>
					</div>	
				</div>
				<div className="prose after-tile">For more information regarding our RVSM Manuals, <a href="/contact-us">contact our team</a>.</div>
				<div className="prose not-first"><span className="highlight">Note:</span> Reference AC 91-85B. RVSM approval B046 is still required for international operations.</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default RvsmOperations